import { z } from 'zod'

/**
 * Resend webhook event types this system records on an email log.
 *
 * Not a Prisma enum: the values contain dots, which are not identifiers, and
 * the column stays a string. The webhook still accepts any Resend `type` and
 * ignores the ones that are not in this list. Readers parse with
 * {@link resendEmailEventSchema}.
 */
export const RESEND_EMAIL_EVENTS = [
  'email.sent',
  'email.delivered',
  'email.delivery_delayed',
  'email.opened',
  'email.clicked',
  'email.bounced',
  'email.complained',
  'email.failed',
  'email.suppressed',
] as const

export const resendEmailEventSchema = z.enum(RESEND_EMAIL_EVENTS)

export type ResendEmailEvent = z.infer<typeof resendEmailEventSchema>
